import type { PayloadAction } from '@reduxjs/toolkit';
import type { RefObject } from 'react';

import { clear } from './editorScene';

// Raw reducer implementation allows us to transport React.RefObject similar to React.Context.

export type SceneRefsState = {
  viewerRef?: RefObject<any>;
};

const initialState: SceneRefsState = {
  viewerRef: undefined,
};

// Attach clear life-cycle to editorSceneSlice reducer.
const clearActionType = clear.type;
const setViewerRefActionType = 'editorSceneRefs/setViewerRef';

export const editorSceneRefsReducer = (
  state = initialState,
  action: PayloadAction<RefObject<any> | void>,
) => {
  switch (action.type) {
    case clearActionType: {
      return { viewerRef: undefined };
    }
    case setViewerRefActionType: {
      const payload = action.payload as RefObject<any>;
      return { ...state, viewerRef: payload };
    }
    default:
      return state;
  }
};

export const setViewerRef = (payload: RefObject<any> | null) => {
  return { type: setViewerRefActionType, payload };
};
